import { showExpandedAnnotationView } from '@store'

// `maxHeight = "auto"` allows the document to fill the viewport
// `width` scales the document. "93%" seems to fill the viewport, but not overlap the controls toolbar

const getImageProps = () => {
    
    let props = [
        'name="image"',
        'value="$ocr"',
        'horizontalAlignment="center"',
    ]
    
    if (showExpandedAnnotationView.getValue() === true)
        props = [
            ...props,
            'width="93%"',
            'maxHeight="auto"',
        ]
    
    return props.join('\n')
    
}

export const createLabelStudioConfig = labelsXml => {
    
    const xml = `<View>
        
        <View style="display: flex">
            <Labels name="label" toName="image">
                ${labelsXml}
            </Labels>
            <Image
                ${getImageProps()}
            />
        </View>
        
        <Rectangle
            name="bbox"
            toName="image"
            strokeWidth="3"
        />
        
        <TextArea
            name="transcription"
            toName="image"
            editable="true"
            perRegion="true"
            required="true"
            maxSubmissions="1"
            rows="5"
            placeholder="Recognized Text"
            displayMode="region-list"
        />
    
    </View>`
    
    const domParser = new DOMParser()
    const dom = domParser.parseFromString(xml, 'text/xml')
    const domErrors = dom.getElementsByTagName('parsererror')
    
    if (domErrors.length > 0) {
        console.warn('createLabelStudioConfig: malformed labels XML', domErrors)
        throw new Error(`createLabelStudioConfig: malformed labels XML\n${xml}`)
    }
    
    return xml
    
}
